const experiences = [
  {
    positionName: "Software Development Intern",
    company: "Paycom",
    location: "Irving, TX",
    start: "MAY 2025",
    end: "AUG 2025",
    desc: [
      "Improved client outreach efficiency by designing and implementing a CRM enrichment microservice that merged 20,000+ internal client records with 5,000+ Google Places API business data using C#, ASP .NET Core, SQL, and React",
      "Reduced RESTful API response latency by 98.6% — 22s to ~300ms — by designing a high-throughput data pipeline with intelligent caching and prefetching layers using C#, ASP .NET Core, SQL, and React",
      "Reduced initial client load time by 60% by implementing lazy loading, efficient state updates, and optimized API response handling on a single-page application using effective React state management and memoization",
    ],
    technologies: "C#, ASP .NET Core, MySQL, GCP Places API, React",
    logo: "/media/paycom_logo.jpg",
  },
  {
    positionName: "Lead Software Engineer",
    company: "Gather (Startup)",
    location: "Dallas, TX",
    start: "NOV 2023",
    end: "AUG 2024",
    desc: [
      "Gained 5,000 downloads and 200,000 views on social media by leading a team in designing, creating, and marketing an event application that college students can use to post their club's or organization's events",
      "Created push notifications using Firebase Cloud Database, improving UI/UX so users can stay up to date on campus events and activities",
    ],
    technologies: "Firebase, React Native, JavaScript",
    logo: "/media/gather_logo.png",
  },
  {
    positionName: "Software Engineer Intern",
    company: "The University of Texas at Dallas",
    location: "Richardson, TX",
    start: "JAN 2024",
    end: "MAY 2024",
    desc: [
      "Lead a team in improving speech recognition accuracy by ~24% for hands-free computer operation by integrating an ML model to process real-time audio input and handle imprecise voice commands using Python",
      "Reduced user interaction latency by up to 3 seconds by fine-tuning ML model parameters to mitigate noise and system interference using Python",
    ],
    technologies: "Python",
    logo: "/media/utd_logo.jpg",
  },
  {
    positionName: "Software Engineer Intern",
    company: "The University of Texas at Dallas",
    location: "Richardson, TX",
    start: "AUG 2022",
    end: "MAY 2023",
    desc: [
      "Streamlined support for 4,000+ clients by developing REST API endpoints and web pages using networking principles, Vue.js, JavaScript, and PostgreSQL",
      "Increased client satisfaction by leading 5 collaborative sessions with the client to develop more requirement-accurate pages in Vue.js, JavaScript, and PostgreSQL",
    ],
    technologies: "Vue.js, JavaScript, PostgreSQL",
    logo: "/media/utd_logo.jpg",
  },
];

export default experiences;
